"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAd = void 0;
var helpers_1 = require("../../../helpers");
var clientSupportsIO_1 = __importDefault(require("../utils/clientSupportsIO"));
var runAuction_1 = __importDefault(require("./runAuction"));
// these are the options we use to lazy load ads. This will run the auction when the ad
// is 50px from the bottom of the users viewport.
var auctionRunnerOptions = {
    rootMargin: "0px 0px",
    root: null,
    threshold: 0,
};
var loadAd = function (adPlacementId, testGroups, adContext, userGeo, userDeviceType) {
    // this is the callback that will start an auction on a lazy loaded ad through intersection observer
    var auctionCallback = function auctionCallback(entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                if (!entry.target.classList.contains("hasRun")) {
                    // if we're intersecting, and an auction hasn't started, start an auction.
                    entry.target.classList.add("hasRun");
                    // once the auction has started, stop observing this entry
                    observer.unobserve(entry.target);
                    (0, runAuction_1.default)(entry.target.getAttribute("id"), testGroups, adContext, userGeo, userDeviceType);
                }
                else {
                    console.warn("auction already ran on intersecting adUnitId: " +
                        entry.target.getAttribute("id"));
                }
            }
        });
    };
    var adContainer = document.getElementById(adPlacementId);
    if ((0, clientSupportsIO_1.default)() && adContainer) {
        var auctionRunner = new IntersectionObserver(auctionCallback, auctionRunnerOptions);
        if (adContainer && !adContainer.classList.contains("hasIO")) {
            adContainer.classList.add("hasIO");
            (0, helpers_1.getCookie)("debug-ads") &&
                console.debug("".concat(adPlacementId, ": observer setup"));
            auctionRunner.observe(adContainer);
        }
    }
    else if (adContainer) {
        if (!adContainer.classList.contains("hasRun")) {
            adContainer.classList.add("hasRun");
            (0, helpers_1.getCookie)("debug-ads") &&
                console.debug("".concat(adPlacementId, ": no IO, running auction directly"));
            (0, runAuction_1.default)(adPlacementId, testGroups, adContext, userGeo, userDeviceType);
        }
        else {
            console.warn("auction already ran on adUnitId: " + adPlacementId);
        }
    }
    else {
        (0, helpers_1.getCookie)("debug-ads") &&
            console.debug("".concat(adPlacementId, ": cannot find adContainer in DOM"));
    }
};
exports.loadAd = loadAd;
exports.default = {
    loadAd: exports.loadAd,
};
